import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import DrawerPageInfo from './components/DrawerPageInfo';

interface PageInfoProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const PageInfo = ({ open, onOpenChange }: PageInfoProps) => {
  const { sidebar } = useDashboard();
  const supportUID = sidebar?.route?.support?.uid;

  if (!supportUID) return null;

  return <DrawerPageInfo supportUID={supportUID} open={open} onOpenChange={onOpenChange} />;
};
export default PageInfo;
